module.exports = __webpack_public_path__ + "img/GAME_LIGHTBUG.617326ad.png";